module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box info-box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._v("\r\n          Search By\r\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Branch"
    }
  }, [_vm._v("Branch")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "branch_id",
      "label": "name",
      "options": _vm.branches,
      "placeholder": "Select Branch"
    },
    on: {
      "input": _vm.branchRecordWithchangeFilter
    },
    model: {
      value: (_vm.branch),
      callback: function($$v) {
        _vm.branch = $$v
      },
      expression: "branch"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_id"
    }
  })], 1), _vm._v(" "), (_vm.user.type == 'admin') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Designation"
    }
  }, [_vm._v("Designation")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "designation_id",
      "label": "name",
      "options": _vm.designations,
      "placeholder": "Select Designation"
    },
    on: {
      "input": _vm.loadStaff
    },
    model: {
      value: (_vm.designation),
      callback: function($$v) {
        _vm.designation = $$v
      },
      expression: "designation"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "designation_id"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.user.type == 'admin' || _vm.user.role_id == 5) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', [_c('label', {
    attrs: {
      "for": "Designation"
    }
  }, [_vm._v("Staff")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "staff_id",
      "label": "name",
      "options": _vm.staffs,
      "placeholder": "Select Staff"
    },
    on: {
      "input": _vm.changeFilter
    },
    model: {
      value: (_vm.staff),
      callback: function($$v) {
        _vm.staff = $$v
      },
      expression: "staff"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "staff_id"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.status),
      expression: "form.status"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('status'),
    },
    attrs: {
      "name": "status"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeFilter]
    }
  }, [(!_vm.form.status) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\r\n                    Select Status\r\n                  ")]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "pending"
    }
  }, [_vm._v("Pending")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "verified"
    }
  }, [_vm._v("Verified")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "reject"
    }
  }, [_vm._v("Reject")])]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "status"
    }
  })], 1)])])])]), _vm._v(" "), (_vm.canAccess('member-view-any')) ? _c('div', {
    staticClass: "info-box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Member List")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  }, [(_vm.canAccess('member-create')) ? _c('a', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "href": ((this.$axios.defaults.baseURL) + "/member/export/excel")
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  }), _vm._v(" Download Excel\r\n            ")]) : _vm._e(), _vm._v(" "), (_vm.canAccess('member-create')) ? _c('button', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.newModal
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add New\r\n            ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.per_page),
      expression: "per_page"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "name": "per_page",
      "aria-controls": "example1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.per_page = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changeFilter()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "25"
    }
  }, [_vm._v("25")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "50"
    }
  }, [_vm._v("50")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "100"
    }
  }, [_vm._v("100")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group pull-left input-group-sm",
    staticStyle: {
      "width": "160px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name_search),
      expression: "name_search"
    }],
    staticClass: "form-control pull-right",
    attrs: {
      "type": "text",
      "name": "name_search",
      "placeholder": "Name, Code, Mobile"
    },
    domProps: {
      "value": (_vm.name_search)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.changeFilter()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name_search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changeFilter()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "input-group pull-right input-group-sm",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.table_search),
      expression: "table_search"
    }],
    staticClass: "form-control pull-right",
    attrs: {
      "type": "text",
      "name": "table_search",
      "placeholder": "Search"
    },
    domProps: {
      "value": (_vm.table_search)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.changeFilter()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.table_search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changeFilter()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-sm table-bordered table-hover"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.rows), function(row, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s((index + _vm.pagination.from)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.user.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.user.name))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.fatherName))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.spouseName))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.dob))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [(row.aadharStatus === 'true') ? _c('i', {
      staticClass: "fa fa-check-circle-o text-success",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (row.aadharStatus === 'false') ? _c('i', {
      staticClass: "fa fa-times-circle-o text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _c('i', {
      staticClass: "fa fa-exclamation-circle text-warning",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\r\n                    " + _vm._s(row.aadharNo) + "\r\n                  ")]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [(row.panStatus === 'true') ? _c('i', {
      staticClass: "fa fa-check text-success",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (row.panStatus === 'false') ? _c('i', {
      staticClass: "fa fa-times text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _c('i', {
      staticClass: "fa fa-exclamation-circle text-warning",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\r\n                    " + _vm._s(row.panNo))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.user.mobileVerify == 'true'),
        expression: "row.user.mobileVerify == 'true'"
      }],
      staticClass: "fa fa-check-circle-o text-success"
    }), _vm._v(" " + _vm._s(row.user.mobile))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.city))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [(row.agent) ? _c('span', [_vm._v(_vm._s(row.agent.name))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [(row.branch) ? _c('span', [_vm._v(_vm._s(row.branch.name))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(_vm._f("myDate")(row.created_at)))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [(row.status == 'verified') ? _c('div', [_c('span', {
      staticClass: "label label-success"
    }, [_vm._v("verified")])]) : _vm._e(), _vm._v(" "), (row.status == 'pending') ? _c('div', [_c('span', {
      staticClass: "label label-warning"
    }, [_vm._v("pending")])]) : _vm._e(), _vm._v(" "), (row.status == 'reject') ? _c('div', [_c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("reject")])]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs text-center"
    }, [(row.user.status == 'active') ? _c('div', [_c('i', {
      staticClass: "text-success fa fa-check-circle",
      staticStyle: {
        "font-size": "20px"
      }
    })]) : _c('div', [_c('i', {
      staticClass: "text-danger fa fa-remove"
    })])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "btn-group"
    }, [_vm._m(2, true), _vm._v(" "), _c('ul', {
      staticClass: "dropdown-menu dropdown-menu-right",
      attrs: {
        "role": "menu"
      }
    }, [(_vm.canAccess('member-create')) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.docModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-file"
    }), _vm._v(" Upload Document ")])]) : _vm._e(), _vm._v(" "), (_vm.canAccess('member-document-verify')) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.verifyModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check-square"
    }), _vm._v(" Verify KYC ")])]) : _vm._e(), _vm._v(" "), (_vm.canAccess('member-view')) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.viewModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    }), _vm._v(" Customer Details ")])]) : _vm._e(), _vm._v(" "), (_vm.canAccess('member-update')) ? _c('li', [_c('a', {
      on: {
        "click": _vm.viewInfo
      }
    }, [_c('i', {
      staticClass: "fa fa-black-tie"
    }), _vm._v(" Customer Cibil")])]) : _vm._e(), _vm._v(" "), ((_vm.user.type != 'admin' && row.status != 'verified') || _vm.user.type == 'admin' && _vm.canAccess('member-update')) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.editModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" Customer Update")])]) : _vm._e(), _vm._v(" "), (_vm.canAccess('member-view')) ? _c('li', [_c('router-link', {
      attrs: {
        "to": /customerloandetails/ + row.user_id
      }
    }, [_c('i', {
      staticClass: "fa fa-leanpub"
    }), _vm._v(" Loan Details")])], 1) : _vm._e()])])])])
  }), 0)])])]), _vm._v(" "), (_vm.pagination.current_page > 0) ? _c('div', {
    staticClass: "box-footer clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._v("\r\n              Showing " + _vm._s(_vm.pagination.from) + " to " + _vm._s(_vm.pagination.to) + " of " + _vm._s(_vm.pagination.total) + " entries\r\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('ul', {
    staticClass: "pagination pagination-sm no-margin pull-right"
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'first')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("«")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'prev')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Prev")])]), _vm._v(" "), (_vm.pagination.current_page > 3) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 3))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page > 2) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page > 1) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 1))])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "active",
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page))])]), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 4)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 1))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 5)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 6)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 3))])]) : _vm._e(), _vm._v(" "), _vm._m(3), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 3)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 3))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 2)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 1)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 1))])]) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page))])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'next')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Next")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'last')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("»")])])])])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "newModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_vm._m(4), _vm._v(" "), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editMode),
      expression: "!editMode"
    }],
    staticClass: "modal-title"
  }, [_vm._v("Add Member Details")]), _vm._v(" "), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editMode),
      expression: "editMode"
    }],
    staticClass: "modal-title"
  }, [_vm._v("\r\n                Update Member Details\r\n              ")])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.editMode ? _vm.editMember() : _vm.createMember()
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "nav-tabs-custom"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "main"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputName"
    }
  }, [_vm._v("Customer Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('name'),
    },
    attrs: {
      "type": "text",
      "name": "name",
      "required": "",
      "placeholder": "Enter Customer name"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "name"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputName"
    }
  }, [_vm._v("(C/O) / Customer Alias Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.alias),
      expression: "form.alias"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('alias'),
    },
    attrs: {
      "type": "text",
      "name": "alias",
      "required": "",
      "placeholder": "Enter Customer alias"
    },
    domProps: {
      "value": (_vm.form.alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "alias", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "alias"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputName2"
    }
  }, [_vm._v("Customer Mobile No.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.mobile),
      expression: "form.mobile"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('mobile'),
    },
    attrs: {
      "type": "number",
      "name": "mobile",
      "required": "",
      "placeholder": "Enter Mobile Number"
    },
    domProps: {
      "value": (_vm.form.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "mobile", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "mobile"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputName2"
    }
  }, [_vm._v("Alternative Mobile No.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.phone),
      expression: "form.phone"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('phone'),
    },
    attrs: {
      "type": "number",
      "name": "phone",
      "placeholder": "Enter Alternative Mobile Number"
    },
    domProps: {
      "value": (_vm.form.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "phone"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputEmail"
    }
  }, [_vm._v("Customer Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.email),
      expression: "form.email"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('email'),
    },
    attrs: {
      "type": "email",
      "name": "email",
      "placeholder": "Enter Customer Email"
    },
    domProps: {
      "value": (_vm.form.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "email"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputSkills"
    }
  }, [_vm._v("Gender")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.gender),
      expression: "form.gender"
    }],
    staticClass: "form-check-input",
    class: {
      'is-invalid': _vm.form.errors.has('gender'),
    },
    attrs: {
      "value": "Male",
      "id": "customRadio1",
      "type": "radio",
      "name": "gender"
    },
    domProps: {
      "checked": _vm._q(_vm.form.gender, "Male")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "gender", "Male")
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "customRadio1"
    }
  }, [_vm._v("Male")]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "gender"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.gender),
      expression: "form.gender"
    }],
    staticClass: "form-check-input",
    class: {
      'is-invalid': _vm.form.errors.has('gender'),
    },
    attrs: {
      "value": "Female",
      "id": "customRadio2",
      "type": "radio",
      "name": "gender"
    },
    domProps: {
      "checked": _vm._q(_vm.form.gender, "Female")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "gender", "Female")
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "customRadio2"
    }
  }, [_vm._v("Female")]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "gender"
    }
  })], 1)]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputSkills"
    }
  }, [_vm._v("Date Of Birth")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.dob),
      expression: "form.dob"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('dob'),
    },
    attrs: {
      "type": "date",
      "name": "dob",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.dob)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "dob", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "dob"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputSkills"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.password),
      expression: "form.password"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('password'),
    },
    attrs: {
      "type": "password",
      "name": "password"
    },
    domProps: {
      "value": (_vm.form.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "password"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputName"
    }
  }, [_vm._v("Pancard Number")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.panNo),
      expression: "form.panNo"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('panNo'),
    },
    attrs: {
      "type": "text",
      "name": "panNo"
    },
    domProps: {
      "value": (_vm.form.panNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "panNo", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "panNo"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputName"
    }
  }, [_vm._v("Adhar Card Number")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.aadharNo),
      expression: "form.aadharNo"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('aadharNo'),
    },
    attrs: {
      "type": "text",
      "name": "aadharNo"
    },
    domProps: {
      "value": (_vm.form.aadharNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "aadharNo", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "aadharNo"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputName"
    }
  }, [_vm._v("Father Name (C/O)")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.fatherName),
      expression: "form.fatherName"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('fatherName'),
    },
    attrs: {
      "type": "text",
      "name": "fatherName"
    },
    domProps: {
      "value": (_vm.form.fatherName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "fatherName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "fatherName"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputName"
    }
  }, [_vm._v("Mother Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.motherName),
      expression: "form.motherName"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('motherName'),
    },
    attrs: {
      "type": "text",
      "name": "motherName"
    },
    domProps: {
      "value": (_vm.form.motherName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "motherName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "motherName"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputName"
    }
  }, [_vm._v("Spouse Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.spouseName),
      expression: "form.spouseName"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('spouseName'),
    },
    attrs: {
      "type": "text",
      "name": "spouseName"
    },
    domProps: {
      "value": (_vm.form.spouseName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "spouseName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "spouseName"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputName2"
    }
  }, [_vm._v("Branch")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.branch_id),
      expression: "form.branch_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('branch_id'),
    },
    attrs: {
      "name": "branch_id",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "branch_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.getBranchAgent]
    }
  }, [(!_vm.form.branch_id) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\r\n                                    Select Branch\r\n                                  ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.branches), function(bra) {
    return _c('option', {
      key: bra.id,
      domProps: {
        "value": bra.id
      }
    }, [_vm._v("\r\n                                    " + _vm._s(bra.name) + "\r\n                                  ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_id"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputPincode"
    }
  }, [_vm._v("Pincode")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.pin),
      expression: "form.pin"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('pin'),
    },
    attrs: {
      "type": "text",
      "name": "pin"
    },
    domProps: {
      "value": (_vm.form.pin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "pin", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "pin"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputName"
    }
  }, [_vm._v("Address")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.address),
      expression: "form.address"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('address'),
    },
    attrs: {
      "type": "text",
      "name": "address",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "address", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "address"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputName"
    }
  }, [_vm._v("Area")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.area),
      expression: "form.area"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('area'),
    },
    attrs: {
      "type": "text",
      "name": "area"
    },
    domProps: {
      "value": (_vm.form.area)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "area", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "area"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputName"
    }
  }, [_vm._v("City")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.city),
      expression: "form.city"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('city'),
    },
    attrs: {
      "type": "text",
      "name": "city",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "city", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "city"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputName"
    }
  }, [_vm._v("District")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.district),
      expression: "form.district"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('district'),
    },
    attrs: {
      "type": "text",
      "name": "district",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.district)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "district", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "district"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputName2"
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.state_id),
      expression: "form.state_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('state_id'),
    },
    attrs: {
      "name": "state_id",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "state_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(!_vm.form.state_id) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\r\n                                    Select State\r\n                                  ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.states), function(stat) {
    return _c('option', {
      key: stat.id,
      domProps: {
        "value": stat.id
      }
    }, [_vm._v("\r\n                                    " + _vm._s(stat.name) + "\r\n                                  ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "state_id"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputName"
    }
  }, [_vm._v("Nominee Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.nomineeName),
      expression: "form.nomineeName"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'nomineeName'
      ),
    },
    attrs: {
      "type": "text",
      "name": "nomineeName"
    },
    domProps: {
      "value": (_vm.form.nomineeName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "nomineeName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "nomineeName"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputEmail"
    }
  }, [_vm._v("Nominee Mobile Number")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.nomineePhone),
      expression: "form.nomineePhone"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'nomineePhone'
      ),
    },
    attrs: {
      "type": "text",
      "name": "nomineePhone"
    },
    domProps: {
      "value": (_vm.form.nomineePhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "nomineePhone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "nomineePhone"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputEmail"
    }
  }, [_vm._v("Nominee Spouse")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.nomineeSpouse),
      expression: "form.nomineeSpouse"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'nomineeSpouse'
      ),
    },
    attrs: {
      "type": "text",
      "name": "nomineeSpouse"
    },
    domProps: {
      "value": (_vm.form.nomineeSpouse)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "nomineeSpouse", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "nomineeSpouse"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputEmail"
    }
  }, [_vm._v("Nominee DOB")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.nomineeDob),
      expression: "form.nomineeDob"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('nomineeDob'),
    },
    attrs: {
      "type": "date",
      "name": "nomineeDob"
    },
    domProps: {
      "value": (_vm.form.nomineeDob)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "nomineeDob", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "nomineeDob"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputName"
    }
  }, [_vm._v("Nominee AdharCard No")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.nomineeAadharNo),
      expression: "form.nomineeAadharNo"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'nomineeAadharNo'
      ),
    },
    attrs: {
      "type": "text",
      "name": "nomineeAadharNo"
    },
    domProps: {
      "value": (_vm.form.nomineeAadharNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "nomineeAadharNo", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "nomineeAadharNo"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [(_vm.user.type === 'admin' || _vm.user.role_id === 5) ? _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.branch_id),
      expression: "form.branch_id"
    }],
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputName2"
    }
  }, [_vm._v("Staff")]) : _vm._e(), _vm._v(" "), (_vm.user.type === 'admin' || _vm.user.role_id === 5) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.branch_id),
      expression: "form.branch_id"
    }],
    staticClass: "col-sm-4"
  }, [_c('v-select', {
    attrs: {
      "name": "agent_id",
      "label": "name",
      "options": _vm.agents,
      "placeholder": "Select Staff"
    },
    on: {
      "input": _vm.getAgentId
    },
    model: {
      value: (_vm.ag),
      callback: function($$v) {
        _vm.ag = $$v
      },
      expression: "ag"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "agent_id"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputName2"
    }
  }, [_vm._v("Purpose")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.purpose_id),
      expression: "form.purpose_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('purpose_id'),
    },
    attrs: {
      "name": "purpose_id",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "purpose_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(!_vm.form.purpose_id) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\r\n                                    Select Purpose\r\n                                  ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.purposes), function(purpose) {
    return _c('option', {
      key: purpose.id,
      domProps: {
        "value": purpose.id
      }
    }, [_vm._v("\r\n                                    " + _vm._s(purpose.purpose) + "\r\n                                  ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "purpose_id"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editMode),
      expression: "editMode"
    }],
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "offset-sm-3 col-sm-9"
  }, [_c('button', {
    staticClass: "btn-primary float-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveMain
    }
  }, [_vm._v("\r\n                                  Next\r\n                                  "), _vm._m(6)])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "uid"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputName"
    }
  }, [_vm._v("Driving License Number")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.drivingLicenceNo),
      expression: "form.drivingLicenceNo"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'drivingLicenceNo'
      ),
    },
    attrs: {
      "type": "text",
      "name": "drivingLicenceNo"
    },
    domProps: {
      "value": (_vm.form.drivingLicenceNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "drivingLicenceNo", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "drivingLicenceNo"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputName"
    }
  }, [_vm._v("Ration Card Number")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.rationCardNo),
      expression: "form.rationCardNo"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'rationCardNo'
      ),
    },
    attrs: {
      "type": "text",
      "name": "rationCardNo"
    },
    domProps: {
      "value": (_vm.form.rationCardNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "rationCardNo", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "rationCardNo"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputName2"
    }
  }, [_vm._v("Passport Number")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.passportNo),
      expression: "form.passportNo"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('passportNo'),
    },
    attrs: {
      "type": "text",
      "name": "passportNo"
    },
    domProps: {
      "value": (_vm.form.passportNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "passportNo", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "passportNo"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputEmail"
    }
  }, [_vm._v("Voter ID Card Number")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.voterIdCardNo),
      expression: "form.voterIdCardNo"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'voterIdCardNo'
      ),
    },
    attrs: {
      "type": "text",
      "name": "voterIdCardNo"
    },
    domProps: {
      "value": (_vm.form.voterIdCardNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "voterIdCardNo", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "voterIdCardNo"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editMode),
      expression: "editMode"
    }],
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('button', {
    staticClass: "btn-primary float-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.backMain
    }
  }, [_vm._m(7), _vm._v("\r\n                                  Back\r\n                                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('button', {
    staticClass: "btn-success float-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveUID
    }
  }, [_vm._v("\r\n                                  Save & Next\r\n                                  "), _vm._m(8)])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "relation"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputName2"
    }
  }, [_vm._v("Bank")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.bank_id),
      expression: "form.bank_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('bank_id'),
    },
    attrs: {
      "name": "bank_id"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "bank_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(!_vm.form.bank_id) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\r\n                                    Select Bank\r\n                                  ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.banks), function(bank) {
    return _c('option', {
      key: bank.id,
      domProps: {
        "value": bank.id
      }
    }, [_vm._v("\r\n                                    " + _vm._s(bank.name) + "\r\n                                  ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "bank_id"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputName"
    }
  }, [_vm._v("Account Holder Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.accountHolderName),
      expression: "form.accountHolderName"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('accountHolderName'),
    },
    attrs: {
      "type": "text",
      "name": "accountHolderName"
    },
    domProps: {
      "value": (_vm.form.accountHolderName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "accountHolderName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "accountHolderName"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputName"
    }
  }, [_vm._v("Account Number")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.accountNumber),
      expression: "form.accountNumber"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('accountNumber'),
    },
    attrs: {
      "type": "text",
      "name": "accountNumber"
    },
    domProps: {
      "value": (_vm.form.accountNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "accountNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "accountNumber"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputName"
    }
  }, [_vm._v("Bank Branch")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.bankBranch),
      expression: "form.bankBranch"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('bankBranch'),
    },
    attrs: {
      "type": "text",
      "name": "bankBranch"
    },
    domProps: {
      "value": (_vm.form.bankBranch)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "bankBranch", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "bankBranch"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputName"
    }
  }, [_vm._v("Bank IFSC Code")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.ifsc),
      expression: "form.ifsc"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('ifsc'),
    },
    attrs: {
      "type": "text",
      "name": "ifsc"
    },
    domProps: {
      "value": (_vm.form.ifsc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "ifsc", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "ifsc"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editMode),
      expression: "editMode"
    }],
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn-primary float-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.backRel
    }
  }, [_vm._m(9), _vm._v("\r\n                                  Back\r\n                                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn-success float-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveRel
    }
  }, [_vm._v("\r\n                                  Save & Next\r\n                                  "), _vm._m(10)])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "income"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputName"
    }
  }, [_vm._v("Job Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.jobType),
      expression: "form.jobType"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('jobType'),
    },
    attrs: {
      "name": "jobType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "jobType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(!_vm.form.jobType) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\r\n                                    Select Job Type\r\n                                  ")]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BUSINESS"
    }
  }, [_vm._v("BUSINESS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SALARIED"
    }
  }, [_vm._v("SALARIED")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SELF EMPLOYED"
    }
  }, [_vm._v("\r\n                                    SELF EMPLOYED\r\n                                  ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SELF EMPLOYED PROFESSIONAL"
    }
  }, [_vm._v("\r\n                                    SELF EMPLOYED PROFESSIONAL\r\n                                  ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "OTHER"
    }
  }, [_vm._v("OTHER")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NONE"
    }
  }, [_vm._v("NONE")])]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "jobType"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputName"
    }
  }, [_vm._v("Income Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.incomeType),
      expression: "form.incomeType"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('incomeType'),
    },
    attrs: {
      "name": "incomeType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "incomeType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(!_vm.form.incomeType) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\r\n                                    Select Income Type\r\n                                  ")]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "GROSS INCOME"
    }
  }, [_vm._v("\r\n                                    Gross Income\r\n                                  ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NET INCOME"
    }
  }, [_vm._v("Net Income")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NONE"
    }
  }, [_vm._v("NONE")])]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "incomeType"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputName"
    }
  }, [_vm._v("Income Amount")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.incomeAmount),
      expression: "form.incomeAmount"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'incomeAmount'
      ),
    },
    attrs: {
      "type": "text",
      "name": "incomeAmount"
    },
    domProps: {
      "value": (_vm.form.incomeAmount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "incomeAmount", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "incomeAmount"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputName2"
    }
  }, [_vm._v("Income Time")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.incomeTime),
      expression: "form.incomeTime"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('incomeTime'),
    },
    attrs: {
      "name": "incomeTime"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "incomeTime", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(!_vm.form.incomeTime) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\r\n                                    Select Income Type\r\n                                  ")]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MONTHLY"
    }
  }, [_vm._v("Monthly")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "YEARLY"
    }
  }, [_vm._v("Yearly")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "WEEKLY"
    }
  }, [_vm._v("Weekly")])]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "incomeTime"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputEmail"
    }
  }, [_vm._v("Min Amount")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.minAmount),
      expression: "form.minAmount"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('minAmount'),
    },
    attrs: {
      "type": "number",
      "name": "minAmount"
    },
    domProps: {
      "value": (_vm.form.minAmount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "minAmount", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "minAmount"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputEmail"
    }
  }, [_vm._v("Max Amount")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.maxAmount),
      expression: "form.maxAmount"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('maxAmount'),
    },
    attrs: {
      "type": "number",
      "name": "maxAmount"
    },
    domProps: {
      "value": (_vm.form.maxAmount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "maxAmount", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "maxAmount"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputName"
    }
  }, [_vm._v("Business Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.businessName),
      expression: "form.businessName"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'businessName'
      ),
    },
    attrs: {
      "type": "text",
      "name": "businessName"
    },
    domProps: {
      "value": (_vm.form.businessName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "businessName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "businessName"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputEmail"
    }
  }, [_vm._v("Business Address")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.businessAddress),
      expression: "form.businessAddress"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'businessAddress'
      ),
    },
    attrs: {
      "type": "text",
      "name": "businessAddress"
    },
    domProps: {
      "value": (_vm.form.businessAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "businessAddress", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "businessAddress"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputEmail"
    }
  }, [_vm._v("Office Phone")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.officePhone),
      expression: "form.officePhone"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'officePhone'
      ),
    },
    attrs: {
      "type": "number",
      "name": "officePhone"
    },
    domProps: {
      "value": (_vm.form.officePhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "officePhone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "officePhone"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editMode),
      expression: "editMode"
    }],
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn-primary float-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.backInc
    }
  }, [_vm._m(11), _vm._v("\r\n                                  Back\r\n                                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn-success float-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveInc
    }
  }, [_vm._v("\r\n                                  Save & Next\r\n                                  "), _vm._m(12)])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "reference"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputName"
    }
  }, [_vm._v("Co-Applicant Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.guarantorName),
      expression: "form.guarantorName"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'guarantorName'
      ),
    },
    attrs: {
      "type": "text",
      "name": "guarantorName"
    },
    domProps: {
      "value": (_vm.form.guarantorName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "guarantorName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "guarantorName"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputName2"
    }
  }, [_vm._v("Co-Applicant Mobile No.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.guarantorPhone),
      expression: "form.guarantorPhone"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'guarantorPhone'
      ),
    },
    attrs: {
      "type": "text",
      "name": "guarantorPhone"
    },
    domProps: {
      "value": (_vm.form.guarantorPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "guarantorPhone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "guarantorPhone"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputEmail"
    }
  }, [_vm._v("Co-Applicant Address")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.guarantorAddress),
      expression: "form.guarantorAddress"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'guarantorAddress'
      ),
    },
    attrs: {
      "type": "text",
      "name": "guarantorAddress"
    },
    domProps: {
      "value": (_vm.form.guarantorAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "guarantorAddress", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "guarantorAddress"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputSkills"
    }
  }, [_vm._v("Co-Applicant Relation")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.guarantorNarration),
      expression: "form.guarantorNarration"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'guarantorNarration'
      ),
    },
    attrs: {
      "type": "text",
      "name": "guarantorNarration"
    },
    domProps: {
      "value": (_vm.form.guarantorNarration)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "guarantorNarration", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "guarantorNarration"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputName"
    }
  }, [_vm._v("Pancard Number")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.guarantorPanNo),
      expression: "form.guarantorPanNo"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'guarantorPanNo'
      ),
    },
    attrs: {
      "type": "text",
      "name": "guarantorPanNo"
    },
    domProps: {
      "value": (_vm.form.guarantorPanNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "guarantorPanNo", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "guarantorPanNo"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "inputName"
    }
  }, [_vm._v("Adhar Card Number")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.guarantorAadharNo),
      expression: "form.guarantorAadharNo"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'guarantorAadharNo'
      ),
    },
    attrs: {
      "type": "text",
      "name": "guarantorAadharNo"
    },
    domProps: {
      "value": (_vm.form.guarantorAadharNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "guarantorAadharNo", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "guarantorAadharNo"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn-primary float-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.backRefer
    }
  }, [_vm._m(13), _vm._v("\r\n                                  Back\r\n                                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn-success float-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editMember
    }
  }, [_vm._v("\r\n                                  Save\r\n                                ")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editMode),
      expression: "!editMode"
    }],
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\r\n                  SAVE\r\n                ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editMode),
      expression: "editMode"
    }],
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\r\n                  UPDATE\r\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\r\n                  CLOSE\r\n                ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "verifyModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.seeUser.user) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "profile-user-img img-fluid img-responsive",
    attrs: {
      "src": this.photo,
      "alt": "User profile picture"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group text-center"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.photoStatus),
      expression: "form.photoStatus"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "photoStatus",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.form.photoStatus, "true")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "photoStatus", "true")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-check text-success"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-success"
  }, [_vm._v("Approve")])]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.photoStatus),
      expression: "form.photoStatus"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "photoStatus",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.form.photoStatus, "false")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "photoStatus", "false")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-remove text-danger"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Reject")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    on: {
      "click": _vm.verifyDocuments
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-xs",
    on: {
      "click": function($event) {
        return _vm.imageZoom(_vm.photo)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" View")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-xs",
    on: {
      "click": _vm.verifyDocuments
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Delete")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', {
    staticClass: "profile-username text-center"
  }, [_vm._v("\r\n                        " + _vm._s(_vm.seeUser.user.name) + " \r\n                      ")]), _vm._v(" "), _c('ul', {
    staticClass: "list-group list-group-unbordered mb-3"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Code")]), _vm._v(" "), (_vm.seeUser.user) ? _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeUser.user.code))]) : _vm._e()]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Contact")]), _vm._v(" "), (_vm.seeUser.user) ? _c('a', {
    staticClass: "pull-right"
  }, [_vm._v("91-" + _vm._s(_vm.seeUser.user.mobile))]) : _vm._e()]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Mobile Number Status")]), _vm._v(" "), (_vm.seeUser.user.mobileVerify == 'true') ? _c('a', {
    staticClass: "pull-right fa fa-check-circle-o text-success"
  }) : _c('a', {
    staticClass: "pull-right fa fa-close text-danger"
  })]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Photo Status")]), _vm._v(" "), (_vm.seeUser.photoStatus == 'true') ? _c('a', {
    staticClass: "pull-right fa fa-check-circle-o text-success"
  }) : _c('a', {
    staticClass: "pull-right fa fa-close text-danger"
  })]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Pancard Status")]), _vm._v(" "), (_vm.seeUser.panStatus == 'true') ? _c('a', {
    staticClass: "pull-right fa fa-check-circle-o text-success"
  }) : _c('a', {
    staticClass: "pull-right fa fa-close text-danger"
  })]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Aadhar Status")]), _vm._v(" "), (_vm.seeUser.aadharStatus == 'true') ? _c('a', {
    staticClass: "pull-right fa fa-check-circle-o text-success"
  }) : _c('a', {
    staticClass: "pull-right fa fa-close text-danger"
  })]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Bank Passbook ")]), _vm._v(" "), (_vm.seeUser.passbookStatus == 'true') ? _c('a', {
    staticClass: "pull-right fa fa-check-circle-o text-success"
  }) : _c('a', {
    staticClass: "pull-right fa fa-close text-danger"
  })]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Ration Card ")]), _vm._v(" "), (_vm.seeUser.rationCardStatus == 'true') ? _c('a', {
    staticClass: "pull-right fa fa-check-circle-o text-success"
  }) : _c('a', {
    staticClass: "pull-right fa fa-close text-danger"
  })]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Driving Licence ")]), _vm._v(" "), (_vm.seeUser.drivingLicenceStatus == 'true') ? _c('a', {
    staticClass: "pull-right fa fa-check-circle-o text-success"
  }) : _c('a', {
    staticClass: "pull-right fa fa-close text-danger"
  })]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("DPN Status")]), _vm._v(" "), (_vm.seeUser.demandProcessingNoteStatus == 'true') ? _c('a', {
    staticClass: "pull-right fa fa-check-circle-o text-success"
  }) : _c('a', {
    staticClass: "pull-right fa fa-close text-danger"
  })]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("JLG Status")]), _vm._v(" "), (_vm.seeUser.jointLiabilityGroupStatus == 'true') ? _c('a', {
    staticClass: "pull-right fa fa-check-circle-o text-success"
  }) : _c('a', {
    staticClass: "pull-right fa fa-close text-danger"
  })]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Co-Applicant Mob ")]), _vm._v(" "), (_vm.seeUser.guarantorStatus == 'true') ? _c('a', {
    staticClass: "pull-right fa fa-check-circle-o text-success"
  }) : _c('a', {
    staticClass: "pull-right fa fa-close text-danger"
  })]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Co-Applicant Photo ")]), _vm._v(" "), (_vm.seeUser.guarantorPhotoStatus == 'true') ? _c('a', {
    staticClass: "pull-right fa fa-check-circle-o text-success"
  }) : _c('a', {
    staticClass: "pull-right fa fa-close text-danger"
  })]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Co-Applicant Aadhar")]), _vm._v(" "), (_vm.seeUser.guarantorAadharStatus == 'true') ? _c('a', {
    staticClass: "pull-right fa fa-check-circle-o text-success"
  }) : _c('a', {
    staticClass: "pull-right fa fa-close text-danger"
  })]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Co-Applicant Pan ")]), _vm._v(" "), (_vm.seeUser.guarantorPanStatus == 'true') ? _c('a', {
    staticClass: "pull-right fa fa-check-circle-o text-success"
  }) : _c('a', {
    staticClass: "pull-right fa fa-close text-danger"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "verifyCustomer"
    }
  }, [_c('div', {
    staticClass: "card card-primary"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.status),
      expression: "form.status"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "status",
      "value": "verified"
    },
    domProps: {
      "checked": _vm._q(_vm.form.status, "verified")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "status", "verified")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-check text-success"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-success"
  }, [_vm._v("Approve")])]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.status),
      expression: "form.status"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "status",
      "value": "pending"
    },
    domProps: {
      "checked": _vm._q(_vm.form.status, "pending")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "status", "pending")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-exclamation-triangle text-warning"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-warning"
  }, [_vm._v("Pending")])]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.status),
      expression: "form.status"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "status",
      "value": "reject"
    },
    domProps: {
      "checked": _vm._q(_vm.form.status, "reject")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "status", "reject")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-remove text-danger"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Reject")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    on: {
      "click": _vm.verifyCustomerStatus
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seeUser.user.mobileVerify != 'true'),
      expression: "seeUser.user.mobileVerify != 'true'"
    }],
    staticClass: "col-md-5 col-xs-12"
  }, [_c('p', [_vm._m(18), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-xs fa fa-paper-plane",
    on: {
      "click": _vm.sendOTP
    }
  }, [_vm._v(" OTP")])]), _vm._v(" "), _c('div', {
    staticClass: "input-group input-group-xs"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.otp),
      expression: "form.otp"
    }],
    staticClass: "form-control input-sm",
    class: {
      'is-invalid': _vm.form.errors.has(
        'otp'
      ),
    },
    attrs: {
      "type": "text",
      "name": "otp",
      "placeholder": "Please Enter OTP"
    },
    domProps: {
      "value": (_vm.form.otp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "otp", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "otp"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.sendOTPVerify
    }
  }, [_c('strong', [_vm._v("Verify OTP")])])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "card border-primary"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_c('h3', {
    staticClass: "profile-username text-center"
  }, [_vm._v("\r\n                                        PANCARD DETAILS\r\n                                      ")]), _vm._v(" "), _c('ul', {
    staticClass: "list-group list-group-unbordered mb-3"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Pancard Number")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seeUser.panNo),
      expression: "seeUser.panNo"
    }],
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeUser.panNo))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Name")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seeUser.user),
      expression: "seeUser.user"
    }],
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeUser.user.name))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Father Name")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seeUser.fatherName),
      expression: "seeUser.fatherName"
    }],
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeUser.fatherName))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("DOB")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seeUser.dob),
      expression: "seeUser.dob"
    }],
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm._f("myDate")(_vm.seeUser.dob)))])])]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "profile-user-img img-fluid",
    attrs: {
      "src": this.pan,
      "alt": "customer pancard picture"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-center"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.panStatus),
      expression: "form.panStatus"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "panStatus",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.form.panStatus, "true")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "panStatus", "true")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-check text-success"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-success"
  }, [_vm._v("Approve")])]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.panStatus),
      expression: "form.panStatus"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "panStatus",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.form.panStatus, "false")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "panStatus", "false")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-remove text-danger"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Reject")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    on: {
      "click": _vm.verifyDocuments
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-xs",
    on: {
      "click": function($event) {
        return _vm.imageZoom(_vm.pan)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" View")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-xs",
    on: {
      "click": _vm.verifyDocuments
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Delete")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "card border-primary"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_c('h3', {
    staticClass: "profile-username text-center"
  }, [_vm._v("\r\n                                        BANK PASSBOOK\r\n                                      ")]), _vm._v(" "), _c('ul', {
    staticClass: "list-group list-group-unbordered mb-3"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Acc. Number")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seeUser.accountNumber),
      expression: "seeUser.accountNumber"
    }],
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeUser.accountNumber))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Account Holder")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seeUser.accountHolderName),
      expression: "seeUser.accountHolderName"
    }],
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeUser.accountHolderName))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Ifsc")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seeUser.ifsc),
      expression: "seeUser.ifsc"
    }],
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeUser.ifsc))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Bank")]), _vm._v(" "), (_vm.seeUser.bank) ? _c('p', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeUser.bank.name))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "profile-user-img img-fluid",
    attrs: {
      "src": this.passbook,
      "alt": "User Bank Passbook"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-center"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.passbookStatus),
      expression: "form.passbookStatus"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "passbookStatus",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.form.passbookStatus, "true")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "passbookStatus", "true")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-check text-success"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-success"
  }, [_vm._v("Approve")])]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.passbookStatus),
      expression: "form.passbookStatus"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "passbookStatus",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.form.passbookStatus, "false")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "passbookStatus", "false")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-remove text-danger"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Reject")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    on: {
      "click": _vm.verifyDocuments
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-xs",
    on: {
      "click": function($event) {
        return _vm.imageZoom(_vm.passbook)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" View")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-xs",
    on: {
      "click": _vm.verifyDocuments
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Delete")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "card card-primary card-outline border-primary"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_c('h3', {
    staticClass: "profile-username text-center"
  }, [_vm._v("\r\n                                        RATIONCARD DETAILS\r\n                                      ")]), _vm._v(" "), _c('ul', {
    staticClass: "list-group list-group-unbordered mb-3"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Rationcard Number")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seeUser.rationCardNo),
      expression: "seeUser.rationCardNo"
    }],
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeUser.rationCardNo))]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Name")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seeUser.user),
      expression: "seeUser.user"
    }],
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeUser.user.name))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Father Name")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seeUser.fatherName),
      expression: "seeUser.fatherName"
    }],
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeUser.fatherName))])])]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "profile-user-img img-fluid",
    attrs: {
      "src": this.rationCard,
      "alt": "User ration Card"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-center"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.rationCardStatus),
      expression: "form.rationCardStatus"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "rationCardStatus",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.form.rationCardStatus, "true")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "rationCardStatus", "true")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-check text-success"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-success"
  }, [_vm._v("Approve")])]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.rationCardStatus),
      expression: "form.rationCardStatus"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "rationCardStatus",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.form.rationCardStatus, "false")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "rationCardStatus", "false")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-remove text-danger"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Reject")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    on: {
      "click": _vm.verifyDocuments
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-xs",
    on: {
      "click": function($event) {
        return _vm.imageZoom(_vm.rationCard)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" View")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-xs",
    on: {
      "click": _vm.verifyDocuments
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Delete")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "card card-primary card-outline border-primary"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_c('h3', {
    staticClass: "profile-username text-center"
  }, [_vm._v("\r\n                                        DRIVING LICENCE\r\n                                      ")]), _vm._v(" "), _c('ul', {
    staticClass: "list-group list-group-unbordered mb-3"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Licence No.")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seeUser.drivingLicenceNo),
      expression: "seeUser.drivingLicenceNo"
    }],
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeUser.drivingLicenceNo))]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Name")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seeUser.user),
      expression: "seeUser.user"
    }],
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeUser.user.name))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Father Name")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seeUser.fatherName),
      expression: "seeUser.fatherName"
    }],
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeUser.fatherName))])])]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "profile-user-img img-fluid",
    attrs: {
      "src": this.drivingLicence,
      "alt": "customer driving licence"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-center"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.drivingLicenceStatus),
      expression: "form.drivingLicenceStatus"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "drivingLicenceStatus",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.form.drivingLicenceStatus, "true")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "drivingLicenceStatus", "true")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-check text-success"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-success"
  }, [_vm._v("Approve")])]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.drivingLicenceStatus),
      expression: "form.drivingLicenceStatus"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "drivingLicenceStatus",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.form.drivingLicenceStatus, "false")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "drivingLicenceStatus", "false")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-remove text-danger"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Reject")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    on: {
      "click": _vm.verifyDocuments
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-xs",
    on: {
      "click": function($event) {
        return _vm.imageZoom(_vm.drivingLicence)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" View")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-xs",
    on: {
      "click": _vm.verifyDocuments
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Delete")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "card card-primary card-outline border-primary"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_c('h3', {
    staticClass: "profile-username text-center"
  }, [_vm._v("\r\n                                        AADHAR DETAILS\r\n                                      ")]), _vm._v(" "), _c('ul', {
    staticClass: "list-group list-group-unbordered mb-3"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Aadhar Number")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seeUser.aadharNo),
      expression: "seeUser.aadharNo"
    }],
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeUser.aadharNo))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Name")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seeUser.user),
      expression: "seeUser.user"
    }],
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeUser.user.name))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Gender")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seeUser.gender),
      expression: "seeUser.gender"
    }],
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeUser.gender))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("DOB")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seeUser.dob),
      expression: "seeUser.dob"
    }],
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm._f("myDate")(_vm.seeUser.dob)))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Address")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seeUser.address),
      expression: "seeUser.address"
    }],
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeUser.address) + " , " + _vm._s(_vm.seeUser.district)), (_vm.seeUser.state) ? _c('span', [_vm._v(", " + _vm._s(_vm.seeUser.state.name))]) : _vm._e(), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br'), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "profile-user-img img-fluid",
    attrs: {
      "src": this.aadhar,
      "alt": "User Aadhar Card"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticClass: "profile-user-img img-fluid",
    attrs: {
      "src": this.aadharBack,
      "alt": "User Aadhar Card"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-center"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.aadharStatus),
      expression: "form.aadharStatus"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "aadharStatus",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.form.aadharStatus, "true")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "aadharStatus", "true")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-check text-success"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-success"
  }, [_vm._v("Approve")])]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.aadharStatus),
      expression: "form.aadharStatus"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "aadharStatus",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.form.aadharStatus, "false")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "aadharStatus", "false")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-remove text-danger"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Reject")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    on: {
      "click": _vm.verifyDocuments
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-xs",
    on: {
      "click": function($event) {
        return _vm.imageZoom(_vm.aadhar)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" Front")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-xs",
    on: {
      "click": function($event) {
        return _vm.imageZoom(_vm.aadharBack)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" Back")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "card card-primary card-outline border-primary"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_c('h3', {
    staticClass: "profile-username text-center"
  }, [_vm._v("\r\n                                        VOTERCARD DETAILS\r\n                                      ")]), _vm._v(" "), _c('ul', {
    staticClass: "list-group list-group-unbordered mb-3"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Number")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seeUser.voterIdCardNo),
      expression: "seeUser.voterIdCardNo"
    }],
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeUser.voterIdCardNo))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Name")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seeUser.user),
      expression: "seeUser.user"
    }],
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeUser.user.name))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Gender")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seeUser.gender),
      expression: "seeUser.gender"
    }],
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeUser.gender))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("DOB")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seeUser.dob),
      expression: "seeUser.dob"
    }],
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm._f("myDate")(_vm.seeUser.dob)))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Address")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seeUser.address),
      expression: "seeUser.address"
    }],
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeUser.address) + " , " + _vm._s(_vm.seeUser.district)), (_vm.seeUser.state) ? _c('span', [_vm._v(", " + _vm._s(_vm.seeUser.state.name))]) : _vm._e()]), _vm._v(" "), _c('br'), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "profile-user-img img-fluid",
    attrs: {
      "src": this.voterCard,
      "alt": "User Aadhar Card"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-center"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.voterCardStatus),
      expression: "form.voterCardStatus"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "voterCardStatus",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.form.voterCardStatus, "true")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "voterCardStatus", "true")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-check text-success"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-success"
  }, [_vm._v("Approve")])]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.voterCardStatus),
      expression: "form.voterCardStatus"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "voterCardStatus",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.form.voterCardStatus, "false")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "voterCardStatus", "false")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-remove text-danger"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Reject")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    on: {
      "click": _vm.verifyDocuments
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-xs",
    on: {
      "click": function($event) {
        return _vm.imageZoom(_vm.voterCard)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" View")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-xs",
    on: {
      "click": _vm.verifyDocuments
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Delete")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card-body box-profile border-primary"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('h3', [_vm._v("DPN")]), _vm._v(" "), _c('img', {
    staticClass: "profile-user-img img-fluid",
    attrs: {
      "src": this.dpn,
      "alt": "User Bank Passbook"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-center"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.demandProcessingNoteStatus),
      expression: "form.demandProcessingNoteStatus"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "demandProcessingNoteStatus",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.form.demandProcessingNoteStatus, "true")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "demandProcessingNoteStatus", "true")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-check text-success"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-success"
  }, [_vm._v("Approve")])]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.demandProcessingNoteStatus),
      expression: "form.demandProcessingNoteStatus"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "demandProcessingNoteStatus",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.form.demandProcessingNoteStatus, "false")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "demandProcessingNoteStatus", "false")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-remove text-danger"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Reject")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    on: {
      "click": _vm.verifyDocuments
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-xs",
    on: {
      "click": function($event) {
        return _vm.imageZoom(_vm.dpn)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" View")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-xs",
    on: {
      "click": _vm.verifyDocuments
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Delete")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card-body box-profile border-primary"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('h3', [_vm._v("JLG")]), _vm._v(" "), _c('img', {
    staticClass: "profile-user-img img-fluid",
    attrs: {
      "src": this.jlg,
      "alt": "User ration Card"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-center"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.jointLiabilityGroupStatus),
      expression: "form.jointLiabilityGroupStatus"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "jointLiabilityGroupStatus",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.form.jointLiabilityGroupStatus, "true")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "jointLiabilityGroupStatus", "true")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-check text-success"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-success"
  }, [_vm._v("Approve")])]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.jointLiabilityGroupStatus),
      expression: "form.jointLiabilityGroupStatus"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "jointLiabilityGroupStatus",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.form.jointLiabilityGroupStatus, "false")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "jointLiabilityGroupStatus", "false")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-remove text-danger"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Reject")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    on: {
      "click": _vm.verifyDocuments
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-xs",
    on: {
      "click": function($event) {
        return _vm.imageZoom(_vm.jlg)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" View")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-xs",
    on: {
      "click": _vm.verifyDocuments
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Delete")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "verifyGuarantor"
    }
  }, [_c('div', {
    staticClass: "card card-primary"
  }, [_vm._m(19), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seeUser.guarantorStatus != 'true'),
      expression: "seeUser.guarantorStatus != 'true'"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('strong', [_c('input', {
    staticClass: "btn btn-info btn-block",
    attrs: {
      "type": "button",
      "value": "Send OTP To Mobile"
    },
    on: {
      "click": _vm.sendOTPGuarantor
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "input-group input-group-sm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.otp),
      expression: "form.otp"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'otp'
      ),
    },
    attrs: {
      "type": "text",
      "name": "otp",
      "placeholder": "Please Enter OTP"
    },
    domProps: {
      "value": (_vm.form.otp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "otp", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "otp"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.sendOTPVerifyGuarantor
    }
  }, [_c('strong', [_vm._v("Verify OTP")])])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "card card-primary card-outline border-primary"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_c('h3', {
    staticClass: "profile-username text-center"
  }, [_vm._v("\r\n                                        Co-Applicant AADHAR DETAILS\r\n                                      ")]), _vm._v(" "), _c('ul', {
    staticClass: "list-group list-group-unbordered mb-3"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Aadhar Number")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seeUser.guarantorAadharNo),
      expression: "seeUser.guarantorAadharNo"
    }],
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeUser.guarantorAadharNo))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Name")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seeUser.guarantorName),
      expression: "seeUser.guarantorName"
    }],
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeUser.guarantorName))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Phone")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seeUser.guarantorPhone),
      expression: "seeUser.guarantorPhone"
    }],
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeUser.guarantorPhone))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Address")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seeUser.guarantorAddress),
      expression: "seeUser.guarantorAddress"
    }],
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeUser.guarantorAddress) + " ")]), _vm._v(" "), _c('br'), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "profile-user-img img-fluid",
    attrs: {
      "src": this.guarantorAadhar,
      "alt": "User profile picture"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "profile-user-img img-fluid",
    attrs: {
      "src": this.guarantorAadharBack,
      "alt": "User profile picture"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-center"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.guarantorAadharStatus),
      expression: "form.guarantorAadharStatus"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "guarantorAadharStatus",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.form.guarantorAadharStatus, "true")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "guarantorAadharStatus", "true")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-check text-success"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-success"
  }, [_vm._v("Approve")])]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.guarantorAadharStatus),
      expression: "form.guarantorAadharStatus"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "guarantorAadharStatus",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.form.guarantorAadharStatus, "false")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "guarantorAadharStatus", "false")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-remove text-danger"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Reject")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    on: {
      "click": _vm.verifyDocuments
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-xs",
    on: {
      "click": function($event) {
        return _vm.imageZoom(_vm.guarantorAadhar)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" Front")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-xs",
    on: {
      "click": function($event) {
        return _vm.imageZoom(_vm.guarantorAadharBack)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" Back")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "card card-primary card-outline border-primary"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_c('h3', {
    staticClass: "profile-username text-center"
  }, [_vm._v("\r\n                                        Co-Applicant PANCARD DETAILS\r\n                                      ")]), _vm._v(" "), _c('ul', {
    staticClass: "list-group list-group-unbordered mb-3"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Pancard Number")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seeUser.guarantorPanNo),
      expression: "seeUser.guarantorPanNo"
    }],
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeUser.guarantorPanNo))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Name")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seeUser.guarantorName),
      expression: "seeUser.guarantorName"
    }],
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeUser.guarantorName))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Narration")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seeUser.guarantorNarration),
      expression: "seeUser.guarantorNarration"
    }],
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeUser.guarantorNarration))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Address")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seeUser.guarantorAddress),
      expression: "seeUser.guarantorAddress"
    }],
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeUser.guarantorAddress) + " ")]), _vm._v(" "), _c('br'), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "profile-user-img img-fluid",
    attrs: {
      "src": this.guarantorPan,
      "alt": "User profile picture"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-center"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.guarantorPanStatus),
      expression: "form.guarantorPanStatus"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "guarantorPanStatus",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.form.guarantorPanStatus, "true")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "guarantorPanStatus", "true")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-check text-success"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-success"
  }, [_vm._v("Approve")])]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.guarantorPanStatus),
      expression: "form.guarantorPanStatus"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "guarantorPanStatus",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.form.guarantorPanStatus, "false")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "guarantorPanStatus", "false")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-remove text-danger"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Reject")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    on: {
      "click": _vm.verifyDocuments
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-xs",
    on: {
      "click": function($event) {
        return _vm.imageZoom(_vm.guarantorPan)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" View")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-xs",
    on: {
      "click": _vm.verifyDocuments
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Delete")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "card-body box-profile border-primary"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('h3', [_vm._v("Co-Applicant PHOTO")]), _vm._v(" "), _c('img', {
    staticClass: "profile-user-img img-fluid",
    attrs: {
      "src": this.guarantorPhoto,
      "alt": "User profile picture"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-center"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.guarantorPhotoStatus),
      expression: "form.guarantorPhotoStatus"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "guarantorPhotoStatus",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.form.guarantorPhotoStatus, "true")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "guarantorPhotoStatus", "true")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-check text-success"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-success"
  }, [_vm._v("Approve")])]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.guarantorPhotoStatus),
      expression: "form.guarantorPhotoStatus"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "guarantorPhotoStatus",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.form.guarantorPhotoStatus, "false")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "guarantorPhotoStatus", "false")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-remove text-danger"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Reject")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    on: {
      "click": _vm.verifyDocuments
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-xs",
    on: {
      "click": function($event) {
        return _vm.imageZoom(_vm.guarantorPhoto)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" View")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-xs",
    on: {
      "click": _vm.verifyDocuments
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Delete")])])])])])])])])])])])])]) : _vm._e()]), _vm._v(" "), _vm._m(20)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "viewModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(21), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.seeUser.user) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "profile-user-img img-fluid img-responsive",
    attrs: {
      "src": this.photo,
      "alt": "User profile picture"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "profile-username text-center"
  }, [_vm._v("\r\n                        " + _vm._s(_vm.seeUser.user.name) + "\r\n                      ")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted text-center"
  }, [_vm._v("\r\n                        Contact - 91-" + _vm._s(_vm.seeUser.user.mobile) + "\r\n                      ")]), _vm._v(" "), _c('ul', {
    staticClass: "list-group list-group-unbordered mb-3"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Email")]), _vm._v(" "), _c('a', {
    staticClass: "float-right"
  }, [_vm._v(_vm._s(_vm.seeUser.user.email))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Phone Number")]), _vm._v(" "), _c('a', {
    staticClass: "float-right"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seeUser.phone),
      expression: "seeUser.phone"
    }]
  }, [_vm._v(_vm._s(_vm.seeUser.phone) + ", ")]), _vm._v(_vm._s(_vm.seeUser.user.mobile))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Gender")]), _vm._v(" "), _c('a', {
    staticClass: "float-right"
  }, [_vm._v(_vm._s(_vm.seeUser.gender))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("DOB")]), _vm._v(" "), _c('a', {
    staticClass: "float-right"
  }, [_vm._v(_vm._s(_vm.seeUser.dob))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Branch")]), _vm._v(" "), _c('a', {
    staticClass: "float-right"
  }, [_vm._v(_vm._s(_vm.seeUser.branch.name))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(22), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "viewrelation"
    }
  }, [_c('div', {
    staticClass: "card card-primary"
  }, [_vm._m(23), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(24), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\r\n                                    " + _vm._s(_vm.seeUser.fatherName) + "\r\n                                  ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(25), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\r\n                                    " + _vm._s(_vm.seeUser.motherName) + "\r\n                                  ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(26), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\r\n                                    " + _vm._s(_vm.seeUser.spouseName) + "\r\n                                  ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(27), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\r\n                                    " + _vm._s(_vm.seeUser.guarantorName) + "\r\n                                  ")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(28), _vm._v(" "), (_vm.seeUser.agent) ? _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\r\n                                    " + _vm._s(_vm.seeUser.agent.name) + " (" + _vm._s(_vm.seeUser.agent.code) + ")\r\n                                  ")]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(29), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\r\n                                    " + _vm._s(_vm.seeUser.guarantorPhone) + "\r\n                                  ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(30), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\r\n                                    " + _vm._s(_vm.seeUser.guarantorAddress) + "\r\n                                  ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(31), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\r\n                                    " + _vm._s(_vm.seeUser.guarantorNarration) + "\r\n                                  ")]), _vm._v(" "), _c('hr')])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "viewlocation"
    }
  }, [_c('div', {
    staticClass: "card card-primary"
  }, [_vm._m(32), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(33), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\r\n                                    " + _vm._s(_vm.seeUser.address) + "\r\n                                  ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(34), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.seeUser.area))]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(35), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.seeUser.city))]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(36), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\r\n                                    " + _vm._s(_vm.seeUser.district) + "\r\n                                  ")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(37), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\r\n                                    " + _vm._s(_vm.seeUser.state.name) + "\r\n                                  ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(38), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\r\n                                    " + _vm._s(_vm.seeUser.state.stateCode) + "\r\n                                  ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(39), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }), _vm._v(" "), _c('hr')])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "viewuid"
    }
  }, [_c('div', {
    staticClass: "card card-primary"
  }, [_vm._m(40), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(41), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.seeUser.panNo))]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(42), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\r\n                                    " + _vm._s(_vm.seeUser.aadharNo) + "\r\n                                  ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(43), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\r\n                                    " + _vm._s(_vm.seeUser.drivingLicenceNo) + "\r\n                                  ")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(44), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\r\n                                    " + _vm._s(_vm.seeUser.rationCardNo) + "\r\n                                  ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(45), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\r\n                                    " + _vm._s(_vm.seeUser.passportNo) + "\r\n                                  ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(46), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\r\n                                    " + _vm._s(_vm.seeUser.voterIdCardNo) + "\r\n                                  ")]), _vm._v(" "), _c('hr')])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "viewincome"
    }
  }, [_c('div', {
    staticClass: "card card-primary"
  }, [_vm._m(47), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(48), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\r\n                                    " + _vm._s(_vm.seeUser.jobType) + "\r\n                                  ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(49), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\r\n                                    " + _vm._s(_vm.seeUser.incomeAmount) + "\r\n                                  ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(50), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\r\n                                    " + _vm._s(_vm.seeUser.incomeType) + "\r\n                                  ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(51), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\r\n                                    " + _vm._s(_vm.seeUser.incomeTime) + "\r\n                                  ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(52), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\r\n                                    " + _vm._s(_vm.seeUser.minAmount) + "\r\n                                  ")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(53), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\r\n                                    " + _vm._s(_vm.seeUser.maxAmount) + "\r\n                                  ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(54), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\r\n                                    " + _vm._s(_vm.seeUser.businessName) + "\r\n                                  ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(55), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\r\n                                    " + _vm._s(_vm.seeUser.businessAddress) + "\r\n                                  ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(56), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\r\n                                    " + _vm._s(_vm.seeUser.officePhone) + "\r\n                                  ")]), _vm._v(" "), _c('hr')])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "viewbusiness"
    }
  }, [_c('div', {
    staticClass: "card card-primary"
  }, [_vm._m(57), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(58), _vm._v(" "), (_vm.seeUser.bank) ? _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\r\n                                    " + _vm._s(_vm.seeUser.bank.name) + "\r\n                                  ")]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(59), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\r\n                                    " + _vm._s(_vm.seeUser.accountHolderName) + "\r\n                                  ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(60), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\r\n                                    " + _vm._s(_vm.seeUser.accountNumber) + "\r\n                                  ")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(61), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\r\n                                    " + _vm._s(_vm.seeUser.bankBranch) + "\r\n                                  ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(62), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.seeUser.ifsc))]), _vm._v(" "), _c('hr')])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "viewnominee"
    }
  }, [_c('div', {
    staticClass: "card card-primary"
  }, [_vm._m(63), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(64), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\r\n                                    " + _vm._s(_vm.seeUser.nomineeName) + "\r\n                                  ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(65), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\r\n                                    " + _vm._s(_vm.seeUser.nomineePhone) + "\r\n                                  ")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(66), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\r\n                                    " + _vm._s(_vm.seeUser.nomineeSpouse) + "\r\n                                  ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(67), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\r\n                                    " + _vm._s(_vm.seeUser.nomineeDob) + "\r\n                                  ")]), _vm._v(" "), _c('hr')])])])])])])])])])]) : _vm._e()]), _vm._v(" "), _vm._m(68)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "docModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(69), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.seeUser.user) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "profile-user-img img-fluid img-responsive",
    attrs: {
      "src": this.photo,
      "alt": "User profile picture"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "profile-username text-center"
  }, [_vm._v("\r\n                        " + _vm._s(_vm.seeUser.user.name) + "\r\n                      ")]), _vm._v(" "), (_vm.seeUser.status !== 'verified') ? _c('div', [(_vm.seeUser.photoStatus != 'true') ? _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*",
      "id": "file-input"
    },
    on: {
      "change": function($event) {
        return _vm.uploadPhoto($event)
      }
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "list-group list-group-unbordered mb-3"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Mobile Number Status")]), _vm._v(" "), (_vm.seeUser.user.mobileVerify == 'true') ? _c('a', {
    staticClass: "pull-right fa fa-check-circle-o text-success"
  }) : _c('a', {
    staticClass: "pull-right fa fa-close text-danger"
  })]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Photo Status")]), _vm._v(" "), (_vm.seeUser.photoStatus == 'true') ? _c('a', {
    staticClass: "pull-right fa fa-check-circle-o text-success"
  }) : _c('a', {
    staticClass: "pull-right fa fa-close text-danger"
  })]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Pancard Status")]), _vm._v(" "), (_vm.seeUser.panStatus == 'true') ? _c('a', {
    staticClass: "pull-right fa fa-check-circle-o text-success"
  }) : _c('a', {
    staticClass: "pull-right fa fa-close text-danger"
  })]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Aadhar Status")]), _vm._v(" "), (_vm.seeUser.aadharStatus == 'true') ? _c('a', {
    staticClass: "pull-right fa fa-check-circle-o text-success"
  }) : _c('a', {
    staticClass: "pull-right fa fa-close text-danger"
  })]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Bank Passbook Status")]), _vm._v(" "), (_vm.seeUser.passbookStatus == 'true') ? _c('a', {
    staticClass: "pull-right fa fa-check-circle-o text-success"
  }) : _c('a', {
    staticClass: "pull-right fa fa-close text-danger"
  })]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Ration Card Status")]), _vm._v(" "), (_vm.seeUser.rationCardStatus == 'true') ? _c('a', {
    staticClass: "pull-right fa fa-check-circle-o text-success"
  }) : _c('a', {
    staticClass: "pull-right fa fa-close text-danger"
  })]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Driving Licence Status")]), _vm._v(" "), (_vm.seeUser.drivingLicenceStatus == 'true') ? _c('a', {
    staticClass: "pull-right fa fa-check-circle-o text-success"
  }) : _c('a', {
    staticClass: "pull-right fa fa-close text-danger"
  })]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Co-Applicant Mob")]), _vm._v(" "), (_vm.seeUser.guarantorStatus == 'true') ? _c('a', {
    staticClass: "pull-right fa fa-check-circle-o text-success"
  }) : _c('a', {
    staticClass: "pull-right fa fa-close text-danger"
  })]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Co-Applicant Photo")]), _vm._v(" "), (_vm.seeUser.guarantorPhotoStatus == 'true') ? _c('a', {
    staticClass: "pull-right fa fa-check-circle-o text-success"
  }) : _c('a', {
    staticClass: "pull-right fa fa-close text-danger"
  })]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Co-Applicant Aadhar")]), _vm._v(" "), (_vm.seeUser.guarantorAadharStatus == 'true') ? _c('a', {
    staticClass: "pull-right fa fa-check-circle-o text-success"
  }) : _c('a', {
    staticClass: "pull-right fa fa-close text-danger"
  })]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Co-Applicant Pan ")]), _vm._v(" "), (_vm.seeUser.guarantorPanStatus == 'true') ? _c('a', {
    staticClass: "pull-right fa fa-check-circle-o text-success"
  }) : _c('a', {
    staticClass: "pull-right fa fa-close text-danger"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(70), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "customerDoc"
    }
  }, [_c('div', {
    staticClass: "card card-primary"
  }, [_vm._m(71), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h3', {
    staticClass: "profile-username text-primary"
  }, [_vm._v("\r\n                                  Adhar Card Front\r\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": this.aadhar,
      "alt": "User profile picture"
    }
  })]), _vm._v(" "), (_vm.seeUser.status !== 'verified') ? _c('div', [(_vm.seeUser.aadharStatus != 'true') ? _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*",
      "id": "file-input"
    },
    on: {
      "change": function($event) {
        return _vm.uploadAadhar($event)
      }
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h3', {
    staticClass: "profile-username text-primary"
  }, [_vm._v("\r\n                                  Adhar Card Back\r\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": this.aadharBack,
      "alt": "User profile picture"
    }
  })]), _vm._v(" "), (_vm.seeUser.status !== 'verified') ? _c('div', [(_vm.seeUser.aadharStatus != 'true') ? _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*",
      "id": "file-input"
    },
    on: {
      "change": function($event) {
        return _vm.uploadAadharBack($event)
      }
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br')])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h3', {
    staticClass: "profile-username text-primary"
  }, [_vm._v("\r\n                                  Pan Card\r\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": this.pan,
      "alt": "User profile picture"
    }
  })]), _vm._v(" "), (_vm.seeUser.status !== 'verified') ? _c('div', [(_vm.seeUser.panStatus != 'true') ? _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*",
      "id": "file-input"
    },
    on: {
      "change": function($event) {
        return _vm.uploadPan($event)
      }
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h3', {
    staticClass: "profile-username text-primary"
  }, [_vm._v("\r\n                                  Voter ID Card\r\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": this.voterCard,
      "alt": "User profile picture"
    }
  })]), _vm._v(" "), (_vm.seeUser.status !== 'verified') ? _c('div', [(_vm.seeUser.voterCardStatus != 'true') ? _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*",
      "id": "file-input"
    },
    on: {
      "change": function($event) {
        return _vm.uploadVoterCard($event)
      }
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br')])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h3', {
    staticClass: "profile-username text-primary"
  }, [_vm._v("\r\n                                  Bank Passbook\r\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": this.passbook,
      "alt": "User profile picture"
    }
  })]), _vm._v(" "), (_vm.seeUser.status !== 'verified') ? _c('div', [(_vm.seeUser.passbookStatus != 'true') ? _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*",
      "id": "file-input"
    },
    on: {
      "change": function($event) {
        return _vm.uploadPassbook($event)
      }
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h3', {
    staticClass: "profile-username text-primary"
  }, [_vm._v("\r\n                                  Ration Card \r\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": this.rationCard,
      "alt": "User profile picture"
    }
  })]), _vm._v(" "), (_vm.seeUser.status !== 'verified') ? _c('div', [(_vm.seeUser.rationCardStatus != 'true') ? _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*",
      "id": "file-input"
    },
    on: {
      "change": function($event) {
        return _vm.uploadRationCard($event)
      }
    }
  }) : _vm._e()]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h3', {
    staticClass: "profile-username text-primary"
  }, [_vm._v("\r\n                                  DPN (Demand Promisary Note)\r\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": this.dpn,
      "alt": "Demand Promisary Note"
    }
  })]), _vm._v(" "), (_vm.seeUser.status !== 'verified') ? _c('div', [(_vm.seeUser.demandProcessingNoteStatus != 'true') ? _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*",
      "id": "file-input"
    },
    on: {
      "change": function($event) {
        return _vm.uploadDPN($event)
      }
    }
  }) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h3', {
    staticClass: "profile-username text-primary"
  }, [_vm._v("\r\n                                  JLG (Joint Liability Groups)\r\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": this.jlg,
      "alt": "Joint Liability Group"
    }
  })]), _vm._v(" "), (_vm.seeUser.status !== 'verified') ? _c('div', [(_vm.seeUser.jointLiabilityGroupStatus != 'true') ? _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*",
      "id": "file-input"
    },
    on: {
      "change": function($event) {
        return _vm.uploadJLG($event)
      }
    }
  }) : _vm._e()]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h3', {
    staticClass: "profile-username text-primary"
  }, [_vm._v("\r\n                                  Driving Licence\r\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": this.drivingLicence,
      "alt": "User profile picture"
    }
  })]), _vm._v(" "), (_vm.seeUser.status !== 'verified') ? _c('div', [(_vm.seeUser.drivingLicenceStatus != 'true') ? _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*",
      "id": "file-input"
    },
    on: {
      "change": function($event) {
        return _vm.uploadDL($event)
      }
    }
  }) : _vm._e()]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "guarantorDoc"
    }
  }, [_c('div', {
    staticClass: "card card-primary"
  }, [_vm._m(72), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h3', {
    staticClass: "profile-username text-primary"
  }, [_vm._v("\r\n                                  Co-Applicant Photo\r\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": this.guarantorPhoto,
      "alt": "User profile picture"
    }
  })]), _vm._v(" "), (_vm.seeUser.status !== 'verified') ? _c('div', [(_vm.seeUser.guarantorPhotoStatus != 'true') ? _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*",
      "id": "file-input"
    },
    on: {
      "change": function($event) {
        return _vm.uploadPhotoGuarantor($event)
      }
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h3', {
    staticClass: "profile-username text-primary"
  }, [_vm._v("\r\n                                  Pan Card\r\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": this.guarantorPan,
      "alt": "User profile picture"
    }
  })]), _vm._v(" "), (_vm.seeUser.status !== 'verified') ? _c('div', [(_vm.seeUser.guarantorPanStatus != 'true') ? _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*",
      "id": "file-input"
    },
    on: {
      "change": function($event) {
        return _vm.uploadPanGuarantor($event)
      }
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h3', {
    staticClass: "profile-username text-primary"
  }, [_vm._v("\r\n                                  Co-Applicant Adhar Front\r\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": this.guarantorAadhar,
      "alt": "User profile picture"
    }
  })]), _vm._v(" "), (_vm.seeUser.status !== 'verified') ? _c('div', [(_vm.seeUser.guarantorAadharStatus != 'true') ? _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*",
      "id": "file-input"
    },
    on: {
      "change": function($event) {
        return _vm.uploadAadharGuarantor($event)
      }
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h3', {
    staticClass: "profile-username text-primary"
  }, [_vm._v("\r\n                                  Co-Applicant Adhar Back\r\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": this.guarantorAadharBack,
      "alt": "User profile picture"
    }
  })]), _vm._v(" "), (_vm.seeUser.status !== 'verified') ? _c('div', [(_vm.seeUser.guarantorAadharStatus != 'true') ? _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*",
      "id": "file-input"
    },
    on: {
      "change": function($event) {
        return _vm.uploadAadharBackGuarantor($event)
      }
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br')])])])])])])])])])])]) : _vm._e()]), _vm._v(" "), _vm._m(73)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "imagemodal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(74), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": this.imagePreview,
      "id": "imagepreview"
    }
  })]), _vm._v(" "), _vm._m(75)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Select Status "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticStyle: {
      "background-color": "#d6dddd"
    }
  }, [_c('tr', [_c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Sr.")]), _vm._v(" "), _c('th', [_vm._v("Code ")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Father Name (C/O)")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Spouse Name")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("BirthDate")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("AadharCardNumber")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("PancardNumber")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Mobile")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("City")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Agent")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Branch")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("CreateDate")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("KYC Status")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-flat btn-xs dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("\r\n                        Action "), _c('span', {
    staticClass: "caret"
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle Dropdown")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "tab1 active"
  }, [_c('a', {
    attrs: {
      "id": "mainDoc",
      "href": "#"
    }
  }, [_vm._v("Main")])]), _vm._v(" "), _c('li', {
    staticClass: "tab2"
  }, [_c('a', {
    attrs: {
      "id": "Identification",
      "href": "#"
    }
  }, [_vm._v("User Identification")])]), _vm._v(" "), _c('li', {
    staticClass: "tab3"
  }, [_c('a', {
    attrs: {
      "id": "relLoc",
      "href": "#"
    }
  }, [_vm._v("Bank Details")])]), _vm._v(" "), _c('li', {
    staticClass: "tab4"
  }, [_c('a', {
    attrs: {
      "id": "inc",
      "href": "#"
    }
  }, [_vm._v("Income")])]), _vm._v(" "), _c('li', {
    staticClass: "tab5"
  }, [_c('a', {
    attrs: {
      "id": "refer",
      "href": "#"
    }
  }, [_vm._v("Co-Applicant Details")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', [_c('i', {
    staticClass: "fa fa-arrow-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', [_c('i', {
    staticClass: "fa fa-arrow-left",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', [_c('i', {
    staticClass: "fa fa-arrow-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', [_c('i', {
    staticClass: "fa fa-arrow-left",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', [_c('i', {
    staticClass: "fa fa-arrow-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', [_c('i', {
    staticClass: "fa fa-arrow-left",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', [_c('i', {
    staticClass: "fa fa-arrow-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', [_c('i', {
    staticClass: "fa fa-arrow-left",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Verify Customer Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-tabs-custom"
  }, [_c('ul', {
    staticClass: "nav nav-pills"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#verifyCustomer",
      "data-toggle": "tab"
    }
  }, [_vm._v("Verify Customer")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#verifyGuarantor",
      "data-toggle": "tab"
    }
  }, [_vm._v("Verify Co-Applicant")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Customer Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("KYC Status ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fa fa-mobile text-danger"
  }), _vm._v(" Customer Mobile Verify")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Co-Applicant Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\r\n                CLOSE\r\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Customer Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header p-2"
  }, [_c('ul', {
    staticClass: "nav nav-pills"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link btn btn-sm btn-info",
    attrs: {
      "href": "#viewrelation",
      "data-toggle": "tab"
    }
  }, [_vm._v("Relation & Reference")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link btn btn-sm btn-info",
    attrs: {
      "href": "#viewlocation",
      "data-toggle": "tab"
    }
  }, [_vm._v("Location")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link btn btn-sm btn-primary",
    attrs: {
      "href": "#viewuid",
      "data-toggle": "tab"
    }
  }, [_vm._v("User ID")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link btn btn-sm btn-info",
    attrs: {
      "href": "#viewincome",
      "data-toggle": "tab"
    }
  }, [_vm._v("Income")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link btn btn-sm btn-warning",
    attrs: {
      "href": "#viewbusiness",
      "data-toggle": "tab"
    }
  }, [_vm._v("Bank Details")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link btn btn-sm btn-info",
    attrs: {
      "href": "#viewnominee",
      "data-toggle": "tab"
    }
  }, [_vm._v("Nominee")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h3', {
    staticClass: "card-title"
  }, [_vm._v("Relation & Reference")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-cash-register mr-1"
  }), _vm._v("Father Name")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-cash-register mr-1"
  }), _vm._v("Mother Name")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-cash-register mr-1"
  }), _vm._v("Spouse Name")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-cash-register mr-1"
  }), _vm._v("Co-Applicant Name")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-cash-register mr-1"
  }), _vm._v("Agent Detail")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-cash-register mr-1"
  }), _vm._v("Co-Applicant Mobile No.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-cash-register mr-1"
  }), _vm._v("\r\n                                    Co-Applicant Address")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-cash-register mr-1"
  }), _vm._v("Co-Applicant Relation")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h3', {
    staticClass: "card-title"
  }, [_vm._v("Location")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-cash-register mr-1"
  }), _vm._v("Address")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-cash-register mr-1"
  }), _vm._v("Area")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-cash-register mr-1"
  }), _vm._v("City")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-cash-register mr-1"
  }), _vm._v("District")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-cash-register mr-1"
  }), _vm._v("State")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-cash-register mr-1"
  }), _vm._v("\r\n                                    State Code")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-cash-register mr-1"
  }), _vm._v("Pincode")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h3', {
    staticClass: "card-title"
  }, [_vm._v("User Identification")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-cash-register mr-1"
  }), _vm._v("Pancard Number")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-cash-register mr-1"
  }), _vm._v("Adhar Card Number")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-cash-register mr-1"
  }), _vm._v("Driving License Number")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-cash-register mr-1"
  }), _vm._v("Ration Card Number")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-cash-register mr-1"
  }), _vm._v("\r\n                                    Passport Number")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-cash-register mr-1"
  }), _vm._v("Voter ID Card Number")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h3', {
    staticClass: "card-title"
  }, [_vm._v("Income")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-cash-register mr-1"
  }), _vm._v("Job Type")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-cash-register mr-1"
  }), _vm._v("Income Amount")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-cash-register mr-1"
  }), _vm._v("Income Type")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-cash-register mr-1"
  }), _vm._v("Income Duration")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-cash-register mr-1"
  }), _vm._v("\r\n                                    Min Amount")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-cash-register mr-1"
  }), _vm._v("\r\n                                    Max Amount")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-cash-register mr-1"
  }), _vm._v("Business Name")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-cash-register mr-1"
  }), _vm._v("Business Address")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-cash-register mr-1"
  }), _vm._v("Office Phone")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h3', {
    staticClass: "card-title"
  }, [_vm._v("\r\n                                Bank Details & Business\r\n                              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-cash-register mr-1"
  }), _vm._v("Bank Name")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-cash-register mr-1"
  }), _vm._v("Account Holder Name")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-cash-register mr-1"
  }), _vm._v("Account Number")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-cash-register mr-1"
  }), _vm._v("Bank Branch")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-cash-register mr-1"
  }), _vm._v("IFSC Code")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h3', {
    staticClass: "card-title"
  }, [_vm._v("Nominee")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-cash-register mr-1"
  }), _vm._v("\r\n                                    Nominee Name")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-cash-register mr-1"
  }), _vm._v("\r\n                                    Nominee Mobile Number")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-cash-register mr-1"
  }), _vm._v("Spouse")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-cash-register mr-1"
  }), _vm._v("Nominee DOB")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\r\n                CLOSE\r\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Customer Documents")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header p-2"
  }, [_c('ul', {
    staticClass: "nav nav-pills"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link btn btn-sm btn-info",
    attrs: {
      "href": "#customerDoc",
      "data-toggle": "tab"
    }
  }, [_vm._v("Customer Documents")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link btn btn-sm btn-info",
    attrs: {
      "href": "#guarantorDoc",
      "data-toggle": "tab"
    }
  }, [_vm._v("Co-Applicant Documents")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Customer Documents")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h2', {
    staticClass: "card-title"
  }, [_vm._v("Co-Applicant Documents")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\r\n                CLOSE\r\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Close")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("Image preview")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7f05f56e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/Customer/Customer.vue
// module id = 847
// module chunks = 0